module.exports = __webpack_public_path__ + "static/media/h-2-01.4ba75338.jpg";